import { useState } from 'react'
import { useAuth } from '../../../contexts/AuthContext'

import { LegalPerson } from './Steps/LegalPerson'
import { NaturalPerson } from './Steps/NaturalPerson'
import { SelectPersonType } from './Steps/SelectPersonType'
import { BankData } from './Steps/BankData'
import { useExpertQuery } from '../../../services/hooks/experts/queries/useExpertQuery'
import { InternationalBankData } from './Steps/InternationalBankData'
import { InternationalPerson } from './Steps/InternationalPerson'

export const CompleteRegistration = () => {
  const { user } = useAuth()
  const { data } = useExpertQuery(user?.id!)
  const [step, setStep] = useState<keyof typeof steps>(0)

  const onChangeStep = (direction: 'previous' | 'next') => () => {
    setStep((previousStep) => {
      const nextStep = previousStep + (direction === 'previous' ? -1 : 1)
      return nextStep as keyof typeof steps
    })
  }

  const steps = {
    0: <SelectPersonType onGoToNextStep={() => setStep(1)} />,
    1: (
      <>
        {data?.personType === 'legal_person' && (
          <LegalPerson
            onGoPreviousStep={onChangeStep('previous')}
            onGoToNextStep={onChangeStep('next')}
          />
        )}
        {data?.personType === 'natural_person' && (
          <NaturalPerson
            onGoPreviousStep={onChangeStep('previous')}
            onGoToNextStep={onChangeStep('next')}
          />
        )}
        {data?.personType === 'international_person' && (
          <InternationalPerson
            onGoPreviousStep={onChangeStep('previous')}
            onGoToNextStep={onChangeStep('next')}
            data={data}
          />
        )}
      </>
    ),
    2: (
      <>
        {data?.personType === 'international_person' ? (
          <InternationalBankData onGoPreviousStep={onChangeStep('previous')} />
        ) : (
          <BankData onGoPreviousStep={onChangeStep('previous')} />
        )}
      </>
    ),
  }

  return <div className="flex flex-col h-full">{steps[step] || null}</div>
}
